import { STOCK_TAKING_CAR_MANAGEMENT_PAGINATED_LOAD } from "../constants"

export function loadTakingCarPaginated(data){
    return (dispatch) =>{
        dispatch({
            type: STOCK_TAKING_CAR_MANAGEMENT_PAGINATED_LOAD,
            data:  data
        })
    }
}